export const EXCMSLA_CREATE_RESET = 'EXCMSLA_CREATE_RESET'
export const EXCMSLA_CREATE_SET_CREATED = 'EXCMSLA_CREATE_SET_CREATED'
export const EXCMSLA_CREATE_SET_ERROR = 'EXCMSLA_CREATE_SET_ERROR'
export const EXCMSLA_CREATE_SET_VIOLATIONS = 'EXCMSLA_CREATE_SET_VIOLATIONS'
export const EXCMSLA_CREATE_TOGGLE_LOADING = 'EXCMSLA_CREATE_TOGGLE_LOADING'
